import {format, parseISO} from 'date-fns'
import React, {useMemo} from 'react'
import {CartesianGrid, ComposedChart, Line, Tooltip, XAxis, YAxis} from 'recharts'
import {UserLite} from '../../../common/types/user'
import {CustomTooltip} from './CustomTooltip'
import {generateUserSignupData} from './utils/generateUserSignupData'

interface Props {
  users: UserLite[]
}

export const UserSignupsOverTime: React.FC<Props> = ({users}) => {
  const data = useMemo(() => generateUserSignupData(users), [users])

  return (
    <ComposedChart width={1000} height={400} data={data} margin={{top: 20, right: 30, bottom: 20, left: 20}}>
      <CartesianGrid stroke="#f5f5f5" />
      <XAxis dataKey="date" tickFormatter={(tick) => format(parseISO(tick), 'MMM d')} />
      <YAxis yAxisId="left" />
      <YAxis yAxisId="right" orientation="right" tickFormatter={(value) => `${value}%`} domain={[0, 100]} />
      <Tooltip content={<CustomTooltip />} />
      <Line yAxisId="left" type="monotone" dataKey="allUsers" stroke="#8884d8" strokeWidth={2} name="Alla användare" />
      <Line yAxisId="left" type="monotone" dataKey="withPayment" stroke="#82ca9d" strokeWidth={2} name="Med betalinfo" />
      <Line yAxisId="left" type="monotone" dataKey="withRentals" stroke="#ff7300" strokeWidth={2} name="Med hyrningar" />
      <Line
        yAxisId="right"
        type="monotone"
        dataKey="paymentShare"
        stroke="#005f73"
        strokeDasharray="3 3"
        strokeWidth={2}
        name="Andel användare som lagt till betalinfo"
      />
      <Line
        yAxisId="right"
        type="monotone"
        dataKey="rentalShare"
        stroke="#9a031e"
        strokeDasharray="4 4"
        strokeWidth={2}
        name="Andel som gjort hyror efter att de lagt till betalinfo"
      />
    </ComposedChart>
  )
}
